import { Prisma } from '@prisma/client';

/**
 * The quote a request was booked on. The variant id is the only link the request holds, so the quotes are searched for
 * the one that owns it — they are passed in rather than read off the request because callers already have them loaded.
 */
export const bookedQuote = <T extends Prisma.QuoteGetPayload<{ select: { quote_variants: { select: { id: true } } } }>>(
  request?: Prisma.RequestGetPayload<{ select: { booked_quote_variant: { select: { id: true } } } }> | null,
  quotes?: T[] | null,
): T | undefined => {
  const bookedVariantId = request?.booked_quote_variant?.id;
  if (!bookedVariantId || !quotes?.length) return undefined;

  return quotes.find((quote) => quote?.quote_variants?.some((variant) => variant?.id === bookedVariantId));
};

/** The variant a request was booked on, taken from the quote that owns it so its line items come along. */
export const bookedVariant = (
  request?: Prisma.RequestGetPayload<{ select: { booked_quote_variant: { select: { id: true } } } }> | null,
  quotes?:
    | Prisma.QuoteGetPayload<{
        select: { quote_variants: { select: { id: true; line_items: { select: { type: true } } } } };
      }>[]
    | null,
) => {
  const bookedVariantId = request?.booked_quote_variant?.id;

  return bookedQuote(request, quotes)?.quote_variants?.find((variant) => variant?.id === bookedVariantId);
};
